/* eslint-disable */
export default {
  removeMeetingWarning:
    'La funzione di pianificazione è fuori produzione. Utilizza {app} per pianificare le riunioni video.',
  scheduleMeetingTips:
    "Le riunioni non sono più disponibili in questa app. Per utilizzare le riunioni, ti consigliamo l'app {app}.",
  migrateToPluginAlert:
    'Nota: questa app non funziona con Outlook 2016 e versioni precedenti e Internet Explorer 11. Aggiorna Outlook o passa a Microsoft Edge. In alternativa passa a {app}',
} as const;

// @key: @#@"removeMeetingWarning"@#@ @source: @#@"The scheduling feature is discontinued. Please use the {app} to schedule your video meetings."@#@
// @key: @#@"scheduleMeetingTips"@#@ @source: @#@"Please note that we removed meetings from this app. To use meetings, we recommend the {app}."@#@
// @key: @#@"migrateToPluginAlert"@#@ @source: @#@"Note: This app will not work with Outlook version 2016 and below and Internet Explorer 11. Please upgrade your Outlook or switch to Microsoft Edge, or alternately, switch to {app}"@#@
